import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;
  position: relative;
`;

export const Wrapper = styled.div`
  ${mediaQuery(BREAKPOINTS.tablet, 'min')} {
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
  }
`;

export const WhatsAppContainer = styled.div<{ mobile?: boolean }>`
  margin-bottom: ${(props) => (props.mobile ? '24px' : '0px')};
  border-radius: 15px;
`;

export const ProContactInfosImg = styled.img`
  object-fit: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
`;

export const ProContactInfosTitleWrapper = styled.div`
  display: flex;
  margin-bottom: 15px;
  justify-content: flex-start;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  text-align: left;
`;
export const ProContactInfosType = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.color.medium.default};
  margin: 0;
`;

export const TermsContainer = styled.span`
  color: ${(props) => props.theme.color.light.default};
  a {
    color: ${(props) => props.theme.color.blue.lightBlue};
  }
`;
